import * as types from 'src/store/types'
import Vue from 'vue'

export default {
  update ({commit}) {
    Vue.axios
      .get('expostat/brand/available/')
      .then(r => r.data)
      .then(brands => {
        commit('updateAvailableBrands', brands)
        // console.log(coins)
      })
    // debugger
  },
  changeCurrent (context, payload) {
    if (context.state.current !== payload) {
      context.commit('changeCurrent', payload)
      context.dispatch('events/resetCurrent', null, {root: true})
      context.dispatch('events/update', null, {root: true})
    }
  }
  // init(context) {
  //   debugger
  // }
};
